import React ,{useEffect,useState} from 'react';
import Select from 'react-select';

const MultiSelect = ({List,selectValue,valueField,labelField,onUserInput,isMulti,placeholder}) => {
    const [options, setOptions] = useState([
        { value: 'Option 1', label: 'Option 1' },
        { value: 'Option 2', label: 'Option 2' },
        { value: 'Option 3', label: 'Option 3' },
        { value: 'Option 4', label: 'Option 4' },
        { value: 'Option 5', label: 'Option 5' },
      ]);
      const [value, setValue] = useState();

    useEffect(() => {
        if (List) {
            setOptions(List.map(item=>{
                return {value:item[valueField|| 'value'],label:item[labelField || 'label']};
            }));
        }

      }, [
        List,valueField,labelField
      ]);

      useEffect(() => {
        if (List) {
           if (isMulti) {
            setValue( List.filter(item => selectValue.includes(item.value)))
           } else {
            setValue(List.find(item => item.value == selectValue));
           }
        }

      }, [setValue, List, selectValue, isMulti]);

      

  const handleChange = (selectedOptions) => {
    console.log('Selected options:', selectedOptions);
    if (selectedOptions && selectedOptions.length>=0)
    onUserInput && onUserInput(selectedOptions.map(item=>item[valueField|| 'value']));
    
  };

  return (

    
      <Select
        isMulti={isMulti}
        value={value}
        options={options}
        onChange={handleChange}
        placeholder={placeholder}
      />
  
  );
};

export default MultiSelect;
